import type { StateKeyT } from "@/types/database/diaries";

import { stateIcons as si } from "./state-icons";

interface StateIconT {
	icon: React.ReactNode;
	name: string;
	states: StateKeyT[];
}

export const stateIcons: StateIconT[] = [
	{
		name: "Never Worked",
		icon: <si.Flag color="red" />,
		states: ["NEVER_WORKED", "HIGH", "LOW"],
	},
	{
		name: "Pain Spike",
		icon: <si.Flag color="amber" />,
		states: ["PAIN_SPIKE"],
	},
	{
		name: "Pain Reduced",
		icon: <si.Flag color="green" />,
		states: ["READY_TO_REVIEW", "PAIN_REDUCED"],
	},
	{
		name: "Active",
		icon: <si.DiaryTick />,
		states: ["NORMAL", "ACTIVE"],
	},
	{
		name: "Discarded",
		icon: <si.Flag color="black" />,
		states: ["DISCARDED"],
	},
	{
		name: "Completed",
		icon: <si.FinishFlag />,
		states: ["COMPLETED"],
	},
	{
		name: "Late to Log",
		icon: <si.DiaryTick />,
		states: ["NORMAL", "ACTIVE"],
	},
	{
		name: "Late to Start",
		icon: <si.MIA />,
		states: ["LATE_TO_LOG", "LATE_TO_START"],
	},
	{
		name: "Pending",
		icon: <si.EmailConfirmed />,
		states: ["PENDING"],
	},
	{
		name: "Empty Diary",
		icon: <si.ClipboardWarning />,
		states: ["EMPTY_DIARY"],
	},
];

export const findStateName = (state: string) => {
	const icon = stateIcons.find((i) => i.states.includes(state))?.name;
	return icon ?? "Unknown State";
};
export const findStateIcon = (state: StateKeyT) => {
	const icon = stateIcons.find((i) => i.states.includes(state))?.icon;
	return icon ? icon : <si.Empty />;
};
